import { makeAutoObservable } from 'mobx';

import { AntSelectOption } from 'controls/react/ant/antSelect';
import { DatasourceEditorProps } from './types';

export class DatasourceEditorStore {
	props: DatasourceEditorProps;

	constructor() {
		makeAutoObservable(this);
	}

	get manager() {
		return this.props?.manager;
	}

	get dataSourceOptions(): AntSelectOption[] {
		return this.manager?.dataSourcesOptions ?? [];
	}
}
